<script>
import { unauthorizedProductsProProps } from "./mixin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import Badge from "@/components/atoms/badge";
import Card from "@/components/molecules/card";
import StickyFooter from "@/components/molecules/sticky-footer";
import Divider from "@/components/atoms/divider";

export default {
  name: "UnauthorizedProductsProMobile",
  components: {
    Button,
    List,
    Icon,
    ButtonIcon,
    ListItem,
    Badge,
    Card,
    StickyFooter,
    Divider
  },
  props: {
    ...unauthorizedProductsProProps()
  },
  emits: ["validate"]
};
</script>

<template>
  <Card
    radius="md"
    elevation="sm"
    class="u-p-md"
  >
    <p class="u-mb-sm u-text-center">
      <Badge
        variant="secondary"
        circle
        size="xlg"
      >
        <Icon
          name="alert"
          variant="white"
          size="lg"
        />
      </Badge>
    </p>
    <h3 class="u-font-24 u-color-secondary u-mt-md u-text-center u-mb-sm">
      Produits non autorisés
    </h3>
    <p class="u-font-16 u-color-grey-1 u-mb-sm">
      Les produits ci-dessous ne sont pas autorisés par votre contrat :
    </p>
    <List>
      <ListItem
        v-for="produit in unauthorizedProducts"
        :key="produit.id"
        class="u-mb-xs u-flex u-flex-align-center"
      >
        <Icon
          name="arrow-right"
          size="sm"
        />
        <span class="u-font-16 u-ml-xs">
          {{ produit.designation }}
        </span>
      </ListItem>
    </List>
    <Divider
      dotted
      class="u-mb-md u-mt-md"
    />
    <p class="u-font-16 u-font-700 u-color-grey-1 u-mt-sm u-mb-sm">
      Vous avez 2 possibilités :
    </p>
    <ul>
      <li class="u-mb-xs">
        En cliquant sur <span class="u-font-700">“Supprimer ces produits et continuer”</span>,
        vous passez à l’étape suivante. Les produits ci-dessus sont alors supprimés automatiquement de votre commande.
      </li>
      <li>
        En cliquant sur <span class="u-font-700">“Modifier et compléter mon panier”</span>, vous revenez à l’étape
        de validation du panier et vous retirez vous-mêmes les produits non autorisés. Vous pourrez alors compléter
        vos courses avec d’autres produits autorisés.
      </li>
    </ul>
    <StickyFooter class="u-flex u-flex-column">
      <Button
        size="md"
        radius="full"
        variant="secondary"
        class="u-mr-sm u-ml-sm"
        @click="$emit('validate')"
      >
        Supprimer {{ pluralize(unauthorizedProducts.length, 'ce') }} {{ pluralize(unauthorizedProducts.length, 'produit') }} et continuer
      </Button>
      <ButtonIcon
        icon-name="arrow-left"
        radius="full"
        variant="primary"
        size="md"
        ouline
        icon-color="white"
        icon-size="sm"
        class="u-mr-sm u-ml-sm u-mt-sm"
        to="/panier"
      >
        Modifier et compléter mon panier
      </ButtonIcon>
    </StickyFooter>
  </Card>
</template>
